var _rect, _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgSkillsInitialsCom(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 36,
    height: 24,
    viewBox: "0 0 36 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 36,
    height: 24,
    fill: "#E6E6E6"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_12985_10675)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 1024,
    height: 768,
    transform: "translate(-412 -235)",
    fill: "#FEFDFB"
  }), /*#__PURE__*/React.createElement("rect", {
    x: -356,
    y: -8,
    width: 912,
    height: 80,
    rx: 8,
    fill: "white"
  }), /*#__PURE__*/React.createElement("rect", {
    x: -355.5,
    y: -7.5,
    width: 911,
    height: 79,
    rx: 7.5,
    stroke: "#071B22",
    strokeOpacity: 0.07
  }), /*#__PURE__*/React.createElement("rect", {
    width: 36,
    height: 24,
    rx: 12,
    fill: "#FFC3A9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.82798 18.4C6.71862 16.6528 6.09998 14.3721 6.09998 12.0001C6.09998 9.62804 6.71862 7.34734 7.82798 5.6001V18.4Z",
    fill: "#FF8853"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18.9 18.4001C17.2026 18.4001 15.5747 17.7258 14.3745 16.5256C13.1743 15.3254 12.5 13.6975 12.5 12.0001C12.5 10.3027 13.1743 8.67485 14.3745 7.47462C15.5747 6.27438 17.2026 5.6001 18.9 5.6001L18.9 18.4001Z",
    fill: "#FF8853"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.95849 16.8311C10.6126 17.5294 11.3938 18.061 12.244 18.4001V5.6001C11.3938 5.93922 10.6126 6.47075 9.95849 7.16905C8.75826 8.45032 8.08398 10.1881 8.08398 12.0001C8.08398 13.8121 8.75826 15.5499 9.95849 16.8311Z",
    fill: "#FF8853"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M29.1953 10.1108H27.8658C27.8146 9.8267 27.7194 9.5767 27.5802 9.3608C27.441 9.14489 27.2706 8.96165 27.0689 8.81108C26.8672 8.66051 26.6413 8.54687 26.3913 8.47017C26.1442 8.39347 25.8814 8.35511 25.603 8.35511C25.1001 8.35511 24.6498 8.48153 24.2521 8.73438C23.8572 8.98722 23.5447 9.35795 23.3146 9.84659C23.0873 10.3352 22.9737 10.9318 22.9737 11.6364C22.9737 12.3466 23.0873 12.946 23.3146 13.4347C23.5447 13.9233 23.8587 14.2926 24.2564 14.5426C24.6541 14.7926 25.1016 14.9176 25.5987 14.9176C25.8743 14.9176 26.1356 14.8807 26.3828 14.8068C26.6328 14.7301 26.8587 14.6179 27.0604 14.4702C27.2621 14.3224 27.4325 14.142 27.5717 13.929C27.7138 13.7131 27.8118 13.4659 27.8658 13.1875L29.1953 13.1918C29.1243 13.6207 28.9865 14.0156 28.7819 14.3764C28.5802 14.7344 28.3203 15.044 28.0021 15.3054C27.6868 15.5639 27.326 15.7642 26.9197 15.9062C26.5135 16.0483 26.0703 16.1193 25.5902 16.1193C24.8345 16.1193 24.1612 15.9403 23.5703 15.5824C22.9794 15.2216 22.5135 14.706 22.1726 14.0355C21.8345 13.3651 21.6655 12.5653 21.6655 11.6364C21.6655 10.7045 21.8359 9.90483 22.1768 9.23722C22.5177 8.56676 22.9837 8.05256 23.5746 7.6946C24.1655 7.33381 24.8373 7.15341 25.5902 7.15341C26.0533 7.15341 26.4851 7.22017 26.8856 7.35369C27.2891 7.48437 27.6513 7.67756 27.9723 7.93324C28.2933 8.18608 28.5589 8.49574 28.7692 8.86222C28.9794 9.22585 29.1214 9.64205 29.1953 10.1108Z",
    fill: "#071B22"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_12985_10675"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 1024,
    height: 768,
    fill: "white",
    transform: "translate(-412 -235)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSkillsInitialsCom);
export default __webpack_public_path__ + "static/media/Skills Initials Com.35d16edfe4ca02b20445d9c27e17a4c8.svg";
export { ForwardRef as ReactComponent };